import {Component, Input, Output, EventEmitter} from '@angular/core';
import {interval, Subscription} from 'rxjs';

@Component({
  selector: 'app-cabecalho-ordenavel',
  template: `
    <span (click)="sort()" (mouseenter)="isShownOrdenacao=true" (mouseleave)="isShownOrdenacao=false">
            {{title}}
      <i *ngIf="!loading && !isShownOrdenacao" class="fas fa-sort float-right" aria-hidden="true"></i>
            <i *ngIf="!loading && isShownOrdenacao && orderDesc" class="fas fa-sort-down float-right" aria-hidden="true"></i>
            <i *ngIf="!loading && isShownOrdenacao && !orderDesc" class="fas fa-sort-up float-right" aria-hidden="true"></i>
            <i *ngIf="loading && showLoading" class="fas spinner-border spinner-border-sm float-right" aria-hidden="true"></i>
        </span>
  `
})
export class CabecalhoOrdenavelComponent {
  @Input() loading: boolean = false;
  @Input() title = 'Título Cabeçalho !';
  @Input() field = 'Campo Ordenação !';
  @Output() onClick = new EventEmitter();
  isShownOrdenacao = false;
  orderDesc = false;
  showLoading = false;
  timerLoading: Subscription;

  constructor() {
  }

  sort() {
    this.showLoading = true;

    this.onClick.emit({
      field: this.field,
      direction: this.orderDesc
    });

    this.orderDesc = !this.orderDesc;

    this.verificaTerminoLoading();
  }

  verificaTerminoLoading() {
    this.timerLoading = interval(500).subscribe(() => {
      if (!this.loading) {
        this.showLoading = false;
        this.timerLoading.unsubscribe();
      }
    });
  }
}
